<h2>{{ notification.messageLanguage?.message }}</h2>
<ng-container *ngFor="let param of notification.parameters | keyvalue"> {{ param.key }} -- {{ param.value }} </ng-container>
